import React, {Component} from 'react'
let sortData = []
export default class SortLocal extends Component {
  constructor(props) {
    super(props)
    let data = this.props.data
    this.state = {
      data,
      sortValue: ''
    }
  }
  componentDidMount() {
    sortData = this.props.data
  }
  componentWillUnmount() {
    sortData = []
  }

  sort = (value, index, direction) => {
    if (direction === null) {
      for (let i = 0; i < sortData.length; i++) {
        sortData[i].sorted = false
        sortData[i].direction = null
      }
      sortData[index].sorted = true
      sortData[index].direction = '1'
      let sortColumn = value
      let sortType = '_desc'
      let sort = {sortType, sortColumn}
      this.props.getSort(sort)
    } else if (direction === '1') {
      for (let i = 0; i < sortData.length; i++) {
        sortData[i].sorted = false
        sortData[i].direction = null
      }
      sortData[index].sorted = true
      sortData[index].direction = '2'
      let sortColumn = value
      let sortType = '_asc'
      let sort = {sortType, sortColumn}

      this.props.getSort(sort)
    } else if (direction === '2') {
      for (let i = 0; i < sortData.length; i++) {
        sortData[i].sorted = false
        sortData[i].direction = null
      }
      sortData[index].sorted = true
      sortData[index].direction = '1'
      let sortColumn = value
      let sortType = '_desc'
      let sort = {sortType, sortColumn}
      this.props.getSort(sort)
    }
  }

  setStyle = (direction) => {
    if (direction === '1') {
      return 'bottomSorted  small font-weight-bold'
    } else if (direction === '2') {
      return 'topSorted  small font-weight-bold'
    } else {
      return ' small font-weight-bold'
    }
  }

  render() {
    return (
      <tr className="firstRow">
        {sortData.map((item, index) => (
          <td
            className={this.setStyle(item.direction)}
            onClick={item.sortable ? () => this.sort(item.value, index, item.direction) : ''}
            style={item.sortable ? {cursor: 'pointer'} : {cursor: 'default'}}
          >
            <span>
              <span>{item.name}</span>
            </span>
            {item.sortable && (
              <span className="position-relative">
                {item.direction === null && item.sortable && (
                  <span className="m-3 sortAnggle" style={{color: '#b0b0b0'}}>
                    <i className="fas fa-sort" />
                  </span>
                )}
                {item.direction === '2' && (
                  <span className="m-3  sortAnggle">
                    <i className="fas fa-caret-up" />
                  </span>
                )}
                {item.direction === '1' && (
                  <span className="m-3  sortAnggle">
                    <i className="fas fa-caret-down" />
                  </span>
                )}
              </span>
            )}
          </td>
        ))}
      </tr>
    )
  }
}
